import { Building2, Clock, DollarSign, MapPin, Users } from "lucide-react";

interface JobContextPanelProps {
  location: string;
  employmentType: string;
  seniorityLevel: string;
  workplaceType: string;
  salaryRange?: string;
}

interface Fact {
  icon: typeof MapPin;
  label: string;
  value?: string;
}

/** Compact, always-visible summary of the role being applied to. */
export function JobContextPanel({
  location,
  employmentType,
  seniorityLevel,
  workplaceType,
  salaryRange,
}: JobContextPanelProps) {
  const facts: Fact[] = [
    { icon: MapPin, label: "Location", value: location },
    { icon: Clock, label: "Type", value: employmentType },
    { icon: Users, label: "Level", value: seniorityLevel },
    { icon: Building2, label: "Workplace", value: workplaceType },
    { icon: DollarSign, label: "Salary", value: salaryRange },
  ].filter((f) => f.value);

  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-3.5">
      {facts.map((f) => (
        <div key={f.label} className="flex items-start gap-2.5">
          <f.icon
            className="mt-0.5 h-4 w-4 shrink-0"
            style={{ color: "rgba(var(--acc2-rgb),0.65)" }}
          />
          <div className="min-w-0">
            <dt
              className="text-[10px] font-bold uppercase tracking-widest"
              style={{ color: "var(--landing-text-dim)" }}
            >
              {f.label}
            </dt>
            <dd
              className="truncate text-sm font-semibold"
              style={{ color: "var(--landing-text)" }}
            >
              {f.value}
            </dd>
          </div>
        </div>
      ))}
    </dl>
  );
}
